import { useCallback, useMemo } from "react";
import { graphql, useStaticQuery } from "gatsby";
import { find, map, toLower } from "lodash";

const useAllFormData = () => {
    const { allWpGfForm } = useStaticQuery(graphql`
        query AllWpGfFormQuery {
            allWpGfForm {
                nodes {
                    ...GravityFormFields
                }
            }
        }
    `);

    const allForms = useMemo(() => {
        return map(allWpGfForm?.nodes, (form) => {
            return {
                ...form,
                labelPlacement: toLower(form.labelPlacement),
                subLabelPlacement: toLower(form.subLabelPlacement),
                descriptionPlacement: toLower(form.descriptionPlacement),
                formFields: map(form?.formFields?.nodes, (field) => {
                    return {
                        ...field,
                        type: toLower(field.type),
                        labelPlacement: toLower(field.labelPlacement),
                        subLabelPlacement: toLower(field.subLabelPlacement),
                        visibility: toLower(field.visibility),
                        descriptionPlacement: toLower(
                            field.descriptionPlacement,
                        ),
                        size: toLower(field.size),
                    };
                }),
            };
        });
    }, [allWpGfForm?.nodes]);

    const getFormById = useCallback(
        (formId) => {
            return find(allForms, { formId });
        },
        [allForms],
    );

    return { allGfForm: allForms, getFormById };
};

export default useAllFormData;
